import { useEffect, useRef, useState } from "react";
import './FadeInComponent.css';

export default function FadeInSection({ children, className }) {
    const domRef = useRef(null);
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        obs.unobserve(entry.target); // 👈 Stop observing after first time
                    }
                });
            },
            { threshold: 0.2 } // Trigger when 20% of element is visible
        );

        if (domRef.current) observer.observe(domRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <span
            ref={domRef}
            className={`${className} w-full fade-in-component transition-opacity duration-700 ${isVisible ? "animate-fadeInUp" : "opacity-0"
                }`}
        >
            {children}
        </span>
    );
}
